module.exports = __webpack_public_path__ + "img/gearVector.53b41e7a.svg";